export const Tabs = (
  classes = {
    tab: '.js-custom-tab',
    tabActive: ['custom-tabs__tab--active'],
  },
) => ({
  allTabs: document.querySelectorAll(classes.tab),
  defaultTabIndex: 0,
  tabs: [],

  init: function init() {
    this.allTabs.forEach((item, index) => {
      const currentTab = item;
      const hasClass = cl => classes.tabActive.includes(cl);
      if ([...item.classList].some(hasClass)) {
        this.defaultTabIndex = index;
      }
      this.tabs.push(currentTab.hash);
    });

    this.setTab(this.defaultTabIndex);

    const elClones = [];
    this.allTabs.forEach(e => elClones.push(e.cloneNode(true)));
    elClones.forEach((e, i) => e.parentNode?.replaceChild(e, elClones[i]));

    this.allTabs.forEach((tab, index) => {
      tab.addEventListener('click', e => {
        e.stopPropagation();
        e.preventDefault();
        this.setTab(index);
      });
    });

    let measurements = store.getAnswers().measurements;

    if (measurements) {
      let measurement = measurements[Object.keys(measurements)[0]].name;
      const measurementTab = document.querySelector(classes.tab + '[data-measurements="' + measurement + '"]');
      measurementTab?.click();
    }
  },
  setTab: function setTab(index) {
    this.tabs.forEach((content, i) => {
      const tabContent = document.querySelector(content);
      const tab = this.allTabs[i];
      const activeClasses = classes.tabActive;
      if (i !== index) {
        tabContent.classList.add('hidden');
        activeClasses.forEach(cl => tab.classList.remove(cl));
      } else {
        tabContent.classList.remove('hidden');
        activeClasses.forEach(cl => tab.classList.add(cl));
      }
    });
  },
});
